import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { useState } from "react";
import { toast } from "react-toastify";
import APIS from "../../constant/Endpoint";
import useDeleteHook from "../../hooks/useDeleteHook";
import OverViewIcon from "../../icons/OverViewIcon copy";

const NavigationListComponent = loadable(
  () => import("../../components/Navigation/List"),
  {
    fallback: (() => {
      return <p>Loading</p>;
    })(),
  }
);

export default function NavigationList() {
  const [showDeletModal, setShowDeleteModal] = useState(false);

  const { mutateAsync: deleteNavigation, isLoading: isDeletingNavigation } =
    useDeleteHook({
      queryKey: ["delete-navigation"],
    });

  const handleDelete = async (id: string) => {
    try {
      const url = `${APIS.NAVIGATION}${id}/`;
      await deleteNavigation({ url });
      setShowDeleteModal(false);
    } catch (error) {
      if (error instanceof Error) toast.error(error.message);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <OverViewIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Navigation</span>
      </div>
      <div>
        <NavigationListComponent
          showDeleteModal={showDeletModal}
          setShowDeleteModal={setShowDeleteModal}
          handleDelete={handleDelete}
          isDeletingNavigation={isDeletingNavigation}
        />
      </div>
    </>
  );
}
